import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';
import { Trans } from 'components';
import { withTranslated } from "components";

const MODAL_ID = 'password-reset-confirm-info';

const PasswordResetConfirmInfo = ({ close, t }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal) => (
      <div>
        <Modal.Heading title={t("Hasło zostało zmienione")} subtitle={t("Zaloguj się używając nowego hasła")} />
        <Modal.Footer>
          <button type="button" onClick={close} className="full-btn has-margin-left"><Trans>Ok, rozumiem</Trans></button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

PasswordResetConfirmInfo.propTypes = {
  close: PropTypes.func.isRequired
}

export default withTranslated(PasswordResetConfirmInfo);


// WEBPACK FOOTER //
// ./src/components/globalModals/PasswordResetConfirmInfo.jsx